import * as React from "react";
import { useMemo, useCallback } from "react";
import SelectEntitiesContext from "./SelectEntitiesContext";
const SelectedEntitiesProvider = ({
  children = void 0,
  isAllRowsSelected,
  isSomeRowsSelected,
  selectedEntities,
  table
}) => {
  const deselectEntity = useCallback(
    (targetEntityId) => table.setRowSelection((cur) => ({ ...cur, [targetEntityId]: false })),
    [table]
  );
  const selectEntity = useCallback(
    (targetEntityId) => table.setRowSelection((cur) => ({ ...cur, [targetEntityId]: true })),
    [table]
  );
  const toggleEntitySelect = useCallback(
    (targetEntityId) => table.setRowSelection((cur) => ({ ...cur, [targetEntityId]: !cur[targetEntityId] })),
    [table]
  );
  const contextValue = useMemo(
    () => ({
      setSelectedEntities: (rows) => table.setRowSelection(Object.fromEntries(rows.map((id) => [id, true]))),
      selectedEntities,
      deselectEntity,
      selectEntity,
      toggleEntitySelect,
      isAllRowsSelected,
      isSomeRowsSelected
    }),
    [selectedEntities, deselectEntity, selectEntity, toggleEntitySelect, table, isAllRowsSelected, isSomeRowsSelected]
  );
  return /* @__PURE__ */ React.createElement(SelectEntitiesContext.Provider, { value: contextValue }, children);
};
export default SelectedEntitiesProvider;
